import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-tooltip-lite';

import { i18n as I18n } from '../../../utils/i18n';

import useIsMobile from '../../../hooks/useIsMobile';

import {
  MOBILE_TOOLTIP_DISTANCE,
  SHARED_TOOLTIP_DISTANCE,
} from '../../../constants/breakpoints';

const ServiceTitle = ({ number, notUnique, title }) => {
  const isMobileView = useIsMobile();

  const titleWithNumber = () => {
    return `${number}. ${
      title === ''
        ? I18n.t('registration.service_details.container_title_new')
        : title
    }`;
  };

  return (
    <h4>
      {notUnique && (
        <Tooltip
          content={I18n.t('registration.service_details.services_not_unique')}
          className="header__not-unique-indicator"
          distance={
            isMobileView ? MOBILE_TOOLTIP_DISTANCE : SHARED_TOOLTIP_DISTANCE
          }
        >
          <i className="fas fa-exclamation-triangle" />
        </Tooltip>
      )}
      {titleWithNumber()}
    </h4>
  );
};

ServiceTitle.propTypes = {
  number: PropTypes.number.isRequired,
  notUnique: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

ServiceTitle.defaultProps = {
  notUnique: false,
};

export default ServiceTitle;
